/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { enviroment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EmployeesapService {
  constructor(private httpClient: HttpClient) {}

  async getEmployeeSapByRut(): Promise<any> {
    return firstValueFrom<any>(
      this.httpClient.get<any>(enviroment.url + 'employeeByRut'),
    );
  }
}
